import { useTheme } from "@emotion/react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import ReactPlayer from "react-player";
import { downloadFile, getPreviewUrl } from "../requests/Requests";
import ButtonCustomStyled from "./DialogComponents/DialogActionButton";
import styles from '../../assets/css/dialogContent.module.css'

import { useState } from "react";
export default function VideoPreviewDialog({ itemId, onClose, id, fileName, sectionName }) {
    const theme = useTheme();
    const [aspectRatio, setAspectRatio] = useState(16 / 9); // default

    const handleReady = (player) => {
        const internal = player.getInternalPlayer();
        if (internal && internal.videoWidth && internal.videoHeight) {
            setAspectRatio(internal.videoWidth / internal.videoHeight);
        }
    };
    return (
        <Dialog
            onClose={onClose}
            open={true}
            maxWidth="xl"
            PaperProps={{
                sx: {
                    width: 'fit-content',
                }
            }}
        >
            <DialogTitle className={styles.padding20}>
                <div style={{ borderBottom: '1px solid #e9e9e9' }}>
                    <span className={styles.previewSection}>{sectionName}</span>
                    <span className={styles.previewFilename}>{fileName}</span>
                </div>
            </DialogTitle>
            <DialogContent
                className={styles.padding020}
                sx={{ overflow: 'hidden' }}
            >
                <div style={{
                    width: `min(85vw, calc((90vh - 140px) * ${aspectRatio}))`,
                    aspectRatio: `${aspectRatio}`,
                    maxWidth: '100%',
                    margin: '0 auto',
                }}>
                    <ReactPlayer
                        url={getPreviewUrl(itemId)}
                        width="100%"
                        height="100%"
                        controls
                        onReady={handleReady}
                    />
                </div>
            </DialogContent>
            <DialogActions className={styles.padding020}>
                <ButtonCustomStyled
                    text="Download"
                    onClick={() => downloadFile(id, fileName)}
                    primary={true}
                />
            </DialogActions>
        </Dialog>
    );
}